import React, { useRef, useState } from "react";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputField from "../../Shared/inputField/inputField";
import Button, {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";
import {
  primaryButtonStyleOkyc,
  primaryButtonHoverStyleOkyc,
} from "../../../../../Shared/buttonStyles";
import { COMPRESSED } from "../../../../../Shared/buttonSize";
import {
  validPhoneNumber,
  validMobileOtpNumber,
} from "../../../../../utils/validation";
import { IdsGenerator } from "../../../../../utils/idGenerator";

function MobileOtpPopup({ handleResponse, name, getOtp }: any) {
  const errorObject = {
    mobileNumberError: false,
    fetchError: false,
    otpError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isOtpTriggered, setIsOtpTriggered] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingForOtp, setLoadingForOtp] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [buttonText, setButtonText] = useState("Send Otp");
  const mobileNumberRef = useRef<any>("");
  const otpRef = useRef<any>("");

  async function checkmobileNumber() {
    try {
      const mobileNumber = mobileNumberRef.current.value;
      if (!validPhoneNumber(mobileNumber)) {
        setError(() => ({
          ...error,
          mobileNumberError: true,
        }));
        resetError();
        return false;
      }
      setLoadingForOtp(true);
      const res = await getOtp(mobileNumber, setLoadingForOtp);
      if (res.result?.otp_sent) {
        setIsOtpTriggered(true);
        setIsOtpSent(true);
        setButtonText("Resend Otp");
        setTimeout(() => setIsOtpSent(false), 30000);
      }
    } catch (e) {
      setError(() => ({
        ...error,
        fetchError: true,
      }));
      resetError();
    }
  }

  function isValid() {
    if (
      validPhoneNumber(mobileNumberRef.current.value.trim()) &&
      otpRef &&
      otpRef.current &&
      validMobileOtpNumber(otpRef.current.value.trim())
    )
      return setIsDisabled(false);
    return setIsDisabled(true);
  }

  function resetError() {
    setTimeout(() => setError({ ...errorObject }), 3000);
  }

  function setOtpStatus() {
    if (isOtpTriggered) setIsOtpTriggered(false);
    setIsDisabled(true);
  }

  function handleCheck() {
    const otp = otpRef.current.value;

    if (!validMobileOtpNumber(otp)) {
      setError(() => ({
        ...error,
        otpError: true,
      }));
      return false;
    } else if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    const consent = isChecked === true ? "Y" : "N";
    setLoading(true);
    handleResponse({ otp, consent }, setLoading);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <div className="d-flex align-items-center">
              <div className="d-flex flex-column">
                <label className={`${Styles.label} flex-grow-1`}>
                  Mobile Number
                </label>
                <div className="d-flex">
                  <div className={Styles.inputContainer}>
                    <InputField
                      id={IdsGenerator({
                        prefix: `${name} popup`,
                        id: "change",
                        suffix: "mobile number",
                      })}
                      maxLength={10}
                      onChange={setOtpStatus}
                      inputRef={mobileNumberRef}
                      isError={error.mobileNumberError}
                      purpose="forOkyc"
                    />
                  </div>
                  <div className={Styles.buttonContainer}>
                    <Button
                      id={IdsGenerator({
                        prefix: `${name} popup`,
                        id: "click",
                        suffix: "send otp",
                      })}
                      hoveredStyle={primaryButtonHoverStyleOkyc}
                      disabled={isOtpSent}
                      size={COMPRESSED}
                      isLoading={loadingForOtp}
                      style={primaryButtonStyleOkyc}
                      onClick={() => {
                        checkmobileNumber();
                      }}
                    >
                      {buttonText}
                    </Button>
                  </div>
                </div>
                {error.fetchError && (
                  <div>
                    <ErrorMessage>
                      Could not fetch info, please try later.
                    </ErrorMessage>
                  </div>
                )}

                {error.mobileNumberError && (
                  <ErrorMessage>
                    Please enter a valid Mobile number
                  </ErrorMessage>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column mb-4 ">
            {isOtpTriggered && (
              <div className="d-flex flex-column">
                <label className={`${Styles.label} flex-grow-1`}>OTP</label>
                <InputField
                  id={IdsGenerator({
                    prefix: `${name} popup`,
                    id: "change",
                    suffix: "otp",
                  })}
                  onChange={isValid}
                  maxLength={6}
                  inputRef={otpRef}
                  isError={error.otpError}
                  purpose="forOtp"
                />
                {error.otpError && (
                  <ErrorMessage>Please enter a valid OTP</ErrorMessage>
                )}
              </div>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: `${name} popup`,
                  id: "check",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: `${name} popup`,
                  id: "check",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => {
                  setIsChecked(e.target.checked);
                  isValid();
                }}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: `${name} popup`,
                id: "click",
                suffix: "run verification",
              })}
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileOtpPopup;
